module.exports = __webpack_public_path__ + "img/doctorsHat_n32.614db6dc.png";